export const BASE_URL_API = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

export const PRIMARY_COLOR = process.env.REACT_APP_PRIMARY_COLOR || "#1A3636";